"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseType = void 0;
var LicenseType;
(function (LicenseType) {
    LicenseType["UNKNOWN"] = "Unknown";
    LicenseType["TRIAL"] = "Trial";
    LicenseType["COMMERCIAL"] = "Commercial";
    LicenseType["SUBSCRIPTION"] = "Subscription";
})(LicenseType || (exports.LicenseType = LicenseType = {}));
